/**
 * Array of feature names.
 * Add treatments name exactly as created.
 */
export const TREATMENTS = [];
